<template>
  <v-data-table v-model="selected"
                dense
                show-select
                :loading="loading"
                :headers="headers"
                :items="subscribers"
                :items-per-page="100"
                item-key="id"
                :search="search"
                :footer-props="{'items-per-page-options': [50, 100, 500, 1000]}">
    <template v-slot:top>
      <v-card-title class="d-flexalign-center">
        {{ subscribers.length | pluralize('Contact') }} on this list
        <v-spacer></v-spacer>

        <v-btn v-if="showRemoveButton"
               @click.prevent="removeSubscribers"
               small
               class="mr-4">
          Remove from list
        </v-btn>

        <v-text-field v-model="search"
                      prepend-inner-icon="fal fa-search"
                      class="pt-0"
                      label="Search"
                      outlined
                      dense
                      hide-details>
        </v-text-field>

      </v-card-title>

      <v-dialog v-if="editedContact"
                v-model="editDialog"
                max-width="800px">
        <edit-user-contact-form :contact="editedContact"
                                @updated="contactUpdated"
                                @closed="closeContactForm">
        </edit-user-contact-form>
      </v-dialog>
    </template>
    <template v-slot:item.contact.email="{item: subscriber}">
      <a @click.prevent="editContact(subscriber.contact)"
         href="#edit-contact">
        {{ subscriber.contact.email }}
      </a>
    </template>
    <template v-slot:item.contact.email_deliverability_status="{item: subscriber}">
      <EmailDeliverabilityStatusWithTooltip :status="subscriber.contact.email_deliverability_status"
                                            :block="true">
      </EmailDeliverabilityStatusWithTooltip>
    </template>
    <template v-slot:item.contact.status="{item: subscriber}">
      <UserContactStatus :contact="subscriber.contact">
      </UserContactStatus>
    </template>
  </v-data-table>
</template>
<script>
import {Form} from 'vform';
import userContactService from '../../../../services/userContactService';
import UserContactForm from "../../../user-contacts/components/UserContactForm";
import AddContactsToListDialog from "../../components/AddContactsToListDialog";
import EditUserContactForm from "../../../user-contacts/components/EditUserContactForm";
import EditUserContact from "../../../user-contacts/EditUserContact";
import EmailDeliverabilityStatusWithTooltip from '../../../neverbounce/components/EmailDeliverabilityStatusWithTooltip.vue';
import {mapGetters} from 'vuex';
import UserContactStatus from '../../../user-contacts/components/UserContactStatus.vue';

export default {
  components: {UserContactStatus, EmailDeliverabilityStatusWithTooltip, EditUserContact, EditUserContactForm, AddContactsToListDialog, UserContactForm},
  props: {
    list: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
    },
    subscribers: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      search: '',
      selected: [],
      deletedContact: null,
      deleteDialog: false,
      deleteForm: new Form(),
      editedContact: null,
      editDialog: false,
      editForm: new Form(userContactService.initForm()),
      newDialog: false,
    }
  },
  computed: {
    ...mapGetters([
      'canVerifyEmails', // MLD-6164
    ]),
    headers() {
      let headers = [
        {
          text: 'Email',
          value: 'contact.email',
        },
        { // MLD-6164
          text: 'Deliverable',
          value: 'contact.email_deliverability_status',
          width: '140px',
        },
        { // MLD-2844
          text: 'Status',
          value: 'contact.status',
          width: '120px',
        },
        { // MLD-5750
          text: 'Greeting',
          value: 'contact.greeting',
          cellClass: 'text-nowrap',
        },
        {
          text: 'Salutation',
          value: 'contact.salutation',
        },
        {
          text: 'Name',
          value: 'contact.name',
        },
      ];
      if (this.canVerifyEmails === false) { // MLD-6164
        headers = headers.filter(h => h.value !== 'contact.email_deliverability_status');
      }
      return headers;
    },
    subscriberIDs() {
      return this.selected.map(s => s.id);
    },
    selectedContacts() {
      return this.selected.map(s => s.contact);
    },
    showRemoveButton() { // MLD-4579
      if (this.selected.length > 0) {
        const routes = [
          `${this.$root.routePrefix}.mailcoach.list.edit`,
          `${this.$root.routePrefix}.mailcoach.campaign.wizard.recipients`,
        ]
        if (routes.includes(this.$route.name)) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    editContact(contact) {
      this.editedContact = contact;
      this.editForm = new Form(userContactService.initForm(contact));
      if (contact) {
        this.editDialog = true;
      } else {
        this.newDialog = true;
      }
    },
    closeContactForm() {
      this.editedContact = null;
      this.editForm = new Form(userContactService.initForm());
      this.editDialog = false;
      this.newDialog = false;
    },
    saveContact() {
      if (this.editedContact) {
        if (this.editedContact.is_unsubscribed) { // MLD-2844
          this.$toast.error('You cannot edit an unsubscribed contact.');
          return;
        }
        this.editForm.put(`/api/user-contacts/${this.editedContact.id}`)
          .then(() => {
            this.$emit('updated')
            this.closeContactForm();
          })
      } else {
        this.editForm.post(`/api/user-contacts`)
          .then(() => {
            this.$emit('updated')
            this.closeContactForm();
          })
      }
    },
    contactUpdated() {
      this.$emit('updated')
      this.closeContactForm();
    },
    removeSubscribers() { // MLD-2668
      const config = {
        data: {
          subscribers: this.subscriberIDs,
        }
      };
      return axios.delete(`/api/mailcoach/lists/${this.list.id}/subscribers`, config)
        .then(response => {
          this.$emit('updated');
          this.selected = [];
        })
    }
  }
}
</script>
